import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { PermissionService } from 'src/app/core/auth/services/permission.service';
import { setAnnouncementsWithPredefinedFilters } from 'src/app/shared/utils/announcements-predefined-filters.utils';
import { AppState } from 'src/app/store';
import { environment } from 'src/environments/environment';
import { Navigation } from '../../../../models/navigation.model';
import * as fromAccountActions from '../../../../store/actions/accounts/accounts.actions';
import * as fromAccountsActions from '../../../../store/actions/accounts/accounts.actions';
import * as fromDashboardActions from '../../../../store/actions/dashboard/dashboard.actions';
import * as fromTemplatesActions from '../../../../store/actions/templates/templates.actions';

@Component({
  selector: 'lns-card-dropdown',
  templateUrl: './card-dropdown.component.html',
  styleUrls: ['./card-dropdown.component.scss']
})
export class CardDropdownComponent {
  @Input() navigations: Navigation[] = [];
  @Input() account!: any;
  @Input() showLeft: any;
  showDropdown = false;

  constructor(
    private store: Store<AppState>,
    private router: Router,
    private permissionService: PermissionService
  ) {}

  dropdownHandler(): void {
    this.showDropdown = !this.showDropdown;
  }

  refreshBalance(): void {
    this.store.dispatch(fromDashboardActions.refreshDashboardApi());
    this.showDropdown = !this.showDropdown;
  }

  announcementHandler(): void {
    this.selectAccount(null);
    setAnnouncementsWithPredefinedFilters(this.store, this.router);
  }

  hasAppPermission(permission: any) {
    return this.permissionService.hasAppPermission(permission);
  }

  hasPrivilege(privilege: any) {
    return this.permissionService.hasPrivilege(privilege);
  }

  selectAccount(nav: any): void {
    if (
      this.account?.accountType.includes('CURRENT_ACCOUNT') ||
      this.account?.accountType.includes('CURRENT_PROXY_ACCOUNT')
    ) {
      this.store.dispatch(
        fromAccountActions.standardAccountSelectActiveAccount({
          selectedAccount: this.account
        })
      );
    } else if (this.account?.accountType.includes('LOAN_ACCOUNT')) {
      this.store.dispatch(
        fromAccountActions.standardAccountSelectActiveLoan({
          selectedLoan: this.account
        })
      );
    } else if (
      this.account?.accountType.includes('SAVINGS_ACCOUNT') ||
      this.account?.accountType.includes('SAVINGS_PROXY_ACCOUNT') ||
      this.account?.accountType.includes('GRADUAL_SAVINGS_ACCOUNT') ||
      this.account?.accountType.includes('GRADUAL_SAVINGS_PROXY_ACCOUNT')
    ) {
      this.store.dispatch(
        fromAccountActions.standardAccountSelectActiveSaving({
          selectedSaving: this.account
        })
      );
    } else if (this.account?.accountType.includes('DEPOSIT_ACCOUNT')) {
      this.store.dispatch(
        fromAccountActions.standardAccountSelectActiveDeposit({
          selectedDeposit: this.account
        })
      );
    }
    if (nav?.name == `ic_option_menu_0`) {
      this.store.dispatch(fromAccountActions.resetAccountTransactionDetails());
      this.store.dispatch(fromTemplatesActions.resetTemplateDetailsForm());
      this.store.dispatch(fromAccountsActions.resetUnsignedOrders());
      this.store.dispatch(
        fromAccountsActions.resetSelectedAccountUnsignedOrders()
      );
      this.router.navigate([nav.route]);
    }
    this.showDropdown = !this.showDropdown;
  }

  checkIfLinkVisible(nav: any) {
    if (
      nav.name === 'ibSpecific.account.e-bills.subscribe' ||
      (nav.name === 'ic_option_menu_3' && environment.retail) ||
      (nav.name === 'ibSpecific.sepa.title_nav' && environment.sme) ||
      (nav.name === 'ic_option_menu_7' && environment.sme)
    ) {
      return false;
    } else return true;
  }
}
